import React, { useState, useContext } from "react"
import Context from "../utils/Context"
import ShowMessage from "../components/ShowMessage"

export default function ModalTrigger() {
  const context = useContext(Context)

  const defaultTriggers = { robot: context.selectedRobot.name }
  const [selectedTriggers, setselectedTriggers] = useState(defaultTriggers)
  const [isEditing, setIsEditing] = useState(false)
  const [removeSelected, setRemoveSelected] = useState(false)

  const c = console.log.bind(document)

  // select trigger
  const selectTrigger = (event) => {
    setRemoveSelected(false)

    c("Trigger selected")

    const trigger =
      event.target.value === ""
        ? defaultTriggers
        : context.availableTriggers.find((trigger) => trigger.name === event.target.value)

    setselectedTriggers(trigger)
    setIsEditing(true)
  }

  // handle trigger selection
  const handleChange = async (target) => {
    setselectedTriggers((selected) => ({ ...selected, [target.id]: target.value }))
  }

  // insert or update item to array helper
  const pushToArray = (obj, arr) => {
    const index = arr.findIndex((e) => e.name === obj.name)
    if (index === -1) {
      arr.push(obj)
    } else {
      arr[index] = obj
    }
    return arr
  }

  // save trigger
  const save = async () => {
    let msg = "Please fill mission name "
    let typeMsg = "error"

    console.log("trying do save trigger", selectedTriggers?.name)

    if (selectedTriggers.name) {
      const newTriggers = pushToArray(selectedTriggers, [...context.availableTriggers])
      context.actions.setAvailableTriggers(newTriggers)
      msg = "Mission saved"
      typeMsg = "success"
    }
    context.actions.setMessage({ message: msg, type: typeMsg })
  }

  // delete trigger
  const remove = () => {
    let newTriggers = [...context.availableTriggers]
    newTriggers.splice(context.availableTriggers.indexOf(selectedTriggers), 1)
    context.actions.setAvailableTriggers(newTriggers)
    clear()
    context.actions.setMessage({ message: "Mission deleted.", type: "success" })
    setRemoveSelected(true)
  }

  // clear for new trigger input
  const clear = () => {
    setselectedTriggers(defaultTriggers)
    setIsEditing(true)
  }

  return (
    <div className="modal is-active">
      <div className="modal-background"></div>

      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <header className="modal-card-head">
          <p className="modal-card-title">Missions</p>

          <button
            className="delete"
            aria-label="close"
            onClick={() => context.actions.setModalState({ ...context.modalState, trigger: false })}
          ></button>
        </header>

        <section className="modal-card-body">
          <div className="field mb-5">
            <label className="label">Missions</label>

            <div className="control">
              <div className="select">
                <select name="trigger" onChange={selectTrigger}
                  defaultValue={"Edit mission..."}>
                  {removeSelected ? (
                    <option selected disabled>Edit mission...</option>
                  ) :
                    <option disabled>Edit mission...</option>
                  }

                  {context.availableTriggers?.map((item, i) =>
                    <option key={i}>
                      {item.name}
                    </option>
                  )}
                </select>
              </div>
            </div>
          </div>

          <div className="field mb-5">
            <label className="label">Name</label>

            <div className="control">
              <input
                id="name"
                type="text"
                className="input"
                placeholder={"New mission name..."}
                value={selectedTriggers && selectedTriggers.name ? selectedTriggers.name : ""}
                onChange={(event) => handleChange(event.target)}
              />
            </div>
          </div>

          <div className="field mb-5">
            <div className="control">
              <button className="button is-success" onClick={save} style={{ marginRight: "1rem" }}>
                Save changes
              </button>

              {isEditing ?
                <button className="button is-danger" onClick={remove}>
                  Delete mission
                </button>
                : null
              }
            </div>

            {selectedTriggers._id &&
              <div className="control">
                <button className="button is-success" onClick={remove}>
                  Delete
                </button>
              </div>
            }
          </div>

          <ShowMessage />
        </section>
      </div>
    </div>
  )
}

